var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}})}
var staticRenderFns = []

export { render, staticRenderFns }